import React from 'react';
import {
  getBrandName,
  isRentalOngoing,
  loadIntercomScript,
  UserDataOutput,
} from 'getaway-data-layer';
import { differenceInMinutes } from 'date-fns';
import { showAlert } from './showAlert';

export const getPhoneCallLink = (phoneNumber: string, title: string) => {
  return <a href={`tel:${phoneNumber}`}>{title}</a>;
};

export const getEmailComposerLink = (email: any, title: string) => {
  return <a href={`mailto:${email}`}>{title}</a>;
};

export const displayEmailComposer = (localize: any, serviceEmail: string) => {
  if (serviceEmail) {
    showAlert(
      localize('help.dialog.title'),
      '',
      getEmailComposerLink(serviceEmail, localize('support.email')),
      () => {},
      localize('cancel')
    );
  }
};

const displayMessenger = (user: UserDataOutput = null, brandSettings) => {
  const customBrand = getBrandName(process.env.VITE_X_BRAND_ID)?.toUpperCase();
  // @ts-ignore force load then open
  if (!window?.Intercom && brandSettings?.intercomAppId) {
    loadIntercomScript(brandSettings?.intercomAppId, true, user);
    return;
  }
  if (user) {
    // First update the user data
    // @ts-ignore
    if (window?.Intercom) {
      // @ts-ignore
      window?.Intercom('update', {
        email: user.email,
        name: `${user.firstName} ${user.lastName}`,
        user_id: user.id,
        custom_user_status: user?.blocked ? 'blocked' : 'active',
        custom_block_reason: user?.blockReasonDetail,
        custom_tariff: user?.tariff?.name,
        custom_brand: customBrand,
        custom_operatorID: user.merchantSystemData?.[0]?.merchantReference
          ? `${user.merchantSystemData?.[0]?.merchantReference}_${user.merchantSystemData?.[0]?.merchantSystem}`
          : '',
      });

      // Then show the messenger
      // @ts-ignore
      window?.Intercom('show');
    }
  } else {
    // @ts-ignore
    if (window?.Intercom) {
      // Update with brand info for anonymous users
      // @ts-ignore
      window?.Intercom('update', {
        custom_brand: customBrand,
      });
      // @ts-ignore
      window?.Intercom('show');
    }
  }
};

export const getIsRentingUser = (
  isVerifiedUser: boolean,
  rentalData: any,
  bookings: any,
  lastFinishedRentalDate: any
): boolean =>
  isVerifiedUser &&
  (isRentalOngoing(rentalData) ||
    bookings?.filter((booking: any) =>
      ['confirmed', 'offered'].includes(booking.status)
    ).length > 0 ||
    (lastFinishedRentalDate &&
      differenceInMinutes(new Date(), new Date(lastFinishedRentalDate)) < 15));

export const openIntercom = (
  localize: any,
  intercomHandlingMode: any,
  isAuthorizedUser: boolean,
  servicePhone: any,
  user: UserDataOutput = null,
  brandSettings = null
) => {
  if (intercomHandlingMode === 'never') {
    showAlert(
      localize('help.dialog.title'),
      '',
      getPhoneCallLink(
        servicePhone || localize('customerSupport.number'),
        localize('support.call')
      ),
      () => {},
      localize('cancel')
    );
  } else if (
    ['always', 'onContactSupport'].includes(intercomHandlingMode) ||
    (intercomHandlingMode === 'onLogin' && isAuthorizedUser)
  ) {
    displayMessenger(user, brandSettings);
  }
};
